import {RouteConfig} from 'vue-router';

import Settings from './pages/Settings.vue';
import Accounts from './pages/Accounts.vue';
import Catalog from './pages/Catalog.vue';
import Districts from './pages/Districts.vue';
import Needs from './pages/Needs.vue';
import Organization from './pages/Organization.vue';
import SocialInquiries from './pages/SocialInquiries.vue';
import CareAllowences from './pages/CareAllowences.vue';
import TerminationReasons from './pages/TerminationReasons.vue';
import PriceLists from './pages/PriceLists.vue';

export default [
    {
        path: '/:tenantId/settings',
        name: 'Settings',
        component: Settings,
        props: (route) => ({tenantId: route.params.tenantId}),
        meta: {
            permissions: [ "Admin" ]
        },
        children: [
            {
                path: 'accounts',
                name: 'Accounts',
                component: Accounts,
                meta: {
                    permissions: [ "Admin" ]
                },
            },
            {
                path: 'catalog',
                name: 'Catalog',
                component: Catalog,
                meta: {
                    permissions: [ "Admin" ]
                },
            },
            {
                path: 'price-lists',
                name: 'PriceLists',
                component: PriceLists,
                meta: {
                    permissions: [ "Admin" ]
                },
            },
            {
                path: 'districts',
                name: 'Districts',
                component: Districts,
                meta: {
                    permissions: [ "Admin" ]
                },
            },
            {
                path: 'needs',
                name: 'Needs',
                component: Needs,
                meta: {
                    permissions: [ "Admin" ]
                },
            },
            {
                path: 'organization',
                name: 'Organization',
                component: Organization,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ "Admin" ]
                },
            },
            {
                path: 'social-inquiries',
                name: 'SocialInquiries',
                component: SocialInquiries,
                meta: {
                    permissions: [ "Admin" ]
                },
            },
            {
                path: 'care-allowences',
                name: 'CareAllowences',
                component: CareAllowences,
                meta: {
                    permissions: [ "Admin" ]
                },
            },
            {
                path: 'termination-reasons',
                name: 'TerminationReasons',
                component: TerminationReasons,
                meta: {
                    permissions: [ "Admin" ]
                },
            }
        ]
    }
] as RouteConfig[];
